import type { FC } from "react";
import { cn } from "../../..";
import type { CardThumbnailBadge } from "./index";

type Props = {
  badge: CardThumbnailBadge;
};

const BadgeChip: FC<Props> = ({ badge }) => (
  <div
    data-slot="card-thumbnail-badge"
    className={cn(
      "absolute top-0 left-1/2 -translate-x-1/2 z-3 inline-flex items-center rounded-b-xs px-1",
      !badge.gradient && badge.color,
    )}
    style={badge.gradient ? { background: badge.gradient } : undefined}
  >
    <span className="font-dm-sans text-[9px] font-semibold leading-3 text-white whitespace-nowrap">
      {badge.label}
    </span>
  </div>
);

export default BadgeChip;
